var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nh-input"},[_c('label',{attrs:{"for":"nh-input"}},[_vm._v(_vm._s(_vm.label)+": ")]),_c('input',{class:{nhDark: _vm.$vuetify.theme.dark, nhLight: !_vm.$vuetify.theme.dark},attrs:{"id":"nh-input","type":"number","min":_vm.min,"max":_vm.max,"size":_vm.max.length + 2},domProps:{"value":_vm.value},on:{"change":_vm.changed}})])
}
var staticRenderFns = []

export { render, staticRenderFns }